export default __webpack_public_path__ + "static/media/thumb-print__icon.d9038bb5.svg";